module.exports = __webpack_public_path__ + "img/04-9.4b7dd471.png";